import { logger } from "logging";
import { toLowerCase } from "./toLowerCase";

/**
 * function that converts first letter of word to capital and remaining small letters
 * @param str - string that is to be capitalized
 * @returns - capitalized string
 */
export const getCapitalizeString = (str: string) => {
  try {
    const lower = toLowerCase(str);
    return str.charAt(0).toUpperCase() + lower.slice(1);
  } catch (error) {
    logger.error(error, "Error in capitalize function");
  }
};
